export default [{
    title: 'Sell My Car',
    image: {
        src: 'https://content.autotrader.com/content/dam/autotrader/collections/landing/additionalservices/sellMyCar.png',
        alt: 'Sell My Car',
    },
    summary: 'Make more money when you sell your car yourself.',
    link: {
        href: '/sell-my-car',
        label: 'Place an ad',
    },
    cmp: 'syc_btn',
},
{
    title: 'Find Out What Your Car Is Worth',
    image: {
        src: 'https://www.autotrader.com/content/dam/autotrader/additionalresources/KBB_Logo_Color_RGB_Small.png',
        alt: 'Find Out What Your Car Is Worth',
    },
    summary: 'Get the value of the car you would like to sell or buy.',
    link: {
        href: '/car-values/',
        label: 'Value a car',
    },
    cmp: 'val_car',
},
{
    title: 'Get an Instant Cash Offer',
    image: {
        src: 'https://content.autotrader.com/content/dam/autotrader/collections/landing/additionalservices/getIco.png',
        alt: 'Get an Instant Cash Offer',
    },
    summary: 'Use the offer to purchase another car or walk away with a check in hand. The choice is yours.',
    link: {
        href: '/instant-cash-offer/?LNX=TIMATCHPLGOTESTGROUPG',
        label: 'Start your offer',
    },
    cmp: 'str_my_off',
},
{
    title: 'Search Certified Cars',
    image: {
        src: 'https://content.autotrader.com/content/dam/autotrader/collections/landing/additionalservices/searchCertifiedCars.png',
        alt: 'Search Certified Cars',
    },
    summary: 'Save money and get a quality used car when you buy a Certified Pre-Owned (CPO) vehicle.',
    link: {
        href: '/certified-cars',
        label: 'Find Certified Cars',
    },
    cmp: 'srch_cert_car',
},
];
